import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PaymentProcessingModal = ({ isOpen, onClose, pilgrim }) => {
  const { currentLanguage, t } = useLanguage();
  const [paymentData, setPaymentData] = useState({
    amount: '',
    paymentMethod: 'cash',
    transactionType: 'down_payment',
    reference: '',
    notes: ''
  });

  const paymentMethodOptions = [
    { value: 'cash', label: t('financial.cash') },
    { value: 'bank_transfer', label: t('financial.bankTransfer') },
    { value: 'check', label: t('financial.check') },
    { value: 'card', label: t('financial.bankCard') }
  ];

  const transactionTypeOptions = [
    { value: 'down_payment', label: t('financial.downPayment') },
    { value: 'balance', label: t('financial.balancePayment') },
    { value: 'adjustment', label: t('financial.adjustment') }
  ];

  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    setIsProcessing(true);
    
    setTimeout(() => {
      setIsProcessing(false);
      onClose();
    }, 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-warm-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">
            {t('financial.processPayment')}
          </h2>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClose}
          />
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-6">
          {pilgrim && (
            <div className="bg-muted rounded-lg p-4">
              <h3 className="caption font-semibold text-foreground mb-3">
                {t('financial.pilgrimInfo')}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <p className="caption text-muted-foreground">
                    {t('financial.name')}
                  </p>
                  <p className="text-sm font-medium text-foreground">{pilgrim?.name}</p>
                </div>
                <div>
                  <p className="caption text-muted-foreground">
                    {t('financial.number')}
                  </p>
                  <p className="text-sm font-medium text-foreground data-text">{pilgrim?.id}</p>
                </div>
              </div>
            </div>
          )}

          <Input
            label={t('financial.amount')}
            type="number"
            placeholder="0.00"
            value={paymentData?.amount}
            onChange={(e) => setPaymentData({ ...paymentData, amount: e?.target?.value })}
            required
          />

          <Select
            label={t('financial.paymentMethod')}
            options={paymentMethodOptions}
            value={paymentData?.paymentMethod}
            onChange={(value) => setPaymentData({ ...paymentData, paymentMethod: value })}
            required
          />

          <Select
            label={t('financial.transactionType')}
            options={transactionTypeOptions}
            value={paymentData?.transactionType}
            onChange={(value) => setPaymentData({ ...paymentData, transactionType: value })}
            required
          />

          <Input
            label={t('financial.reference')}
            type="text"
            placeholder={t('financial.reference')}
            value={paymentData?.reference}
            onChange={(e) => setPaymentData({ ...paymentData, reference: e?.target?.value })}
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              {t('financial.notes')}
            </label>
            <textarea
              className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
              rows="3"
              placeholder={t('financial.notes')}
              value={paymentData?.notes}
              onChange={(e) => setPaymentData({ ...paymentData, notes: e?.target?.value })}
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-end pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isProcessing}
            >
              {t('financial.cancel')}
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Check"
              iconPosition="left"
              loading={isProcessing}
            >
              {isProcessing ? t('financial.processing') : t('financial.processPayment')}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentProcessingModal;